<template>
  <div class="row">
    <div class="col-12 col-md-9">
      <div class="form-group">
        <label class="required"> Select files </label>
        <div class="input-group">
          <div class="select-file">
            <input id="file" type="file" accept=".csv,.xlsx,.xls,.txt" @change="fileSelected($event)" />
            <div v-if="file">
              <span>{{ file.name }}</span>
            </div>
            <div v-else><span>Choose file</span> or drop file here</div>
          </div>
        </div>
        <div v-if="error" class="text-danger">
          {{ error }}
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <label>File requirements</label>
      <div class="file-requirements">
        <div class="requirements-list">
          <div>Format: <strong>CSV, TXT, XLSX</strong></div>
          <div>Max size: <strong>50mb</strong></div>
          <div>DDS reference is optional. Leave the cell blank or omit the column if not needed.</div>
        </div>
        <a
          v-b-tooltip="{
            title:
              'CSV files support most common delimiters are: a comma\n' +
              '<code>,</code>, semicolon <code>;</code> and tab <code>\\t</code>',
          }"
          :href="`${sampleBaseUrl}sample-spreadsheet.txt`"
          class="download-sample"
          download="sample-spreadsheet.txt"
        >
          Download TXT example files
        </a>
        <a
          v-b-tooltip="{
            title:
              'TXT files support most common delimiters are: a comma\n' +
              '<code>,</code>, semicolon <code>;</code> and tab <code>\\t</code>',
          }"
          :href="`${sampleBaseUrl}sample-spreadsheet.csv`"
          class="download-sample"
          download="sample-spreadsheet.csv"
        >
          Download CSV example files
        </a>
        <a
          :href="`${sampleBaseUrl}sample-spreadsheet.xlsx`"
          class="download-sample"
          download="sample-spreadsheet.xlsx"
        >
          Download XLSX example file
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, type Ref, type ComputedRef, computed } from 'vue'
import { useAssignmentFormStore } from '@/store/assignmentForm'

export default defineComponent({
  name: 'UploadFile',
  setup() {
    const assignmentFormStore = useAssignmentFormStore()
    const file: Ref<File | null> = ref(null)
    const sampleBaseUrl: string = import.meta.env.BASE_URL

    const error: ComputedRef<string> = computed(() => assignmentFormStore.errors.file)

    const fileSelected = (event: Event) => {
      const input = event.target as HTMLInputElement
      file.value = input?.files?.[0] || null

      assignmentFormStore.setFields({ file: file.value })
    }

    return {
      file,
      sampleBaseUrl,
      error,
      fileSelected,
    }
  },
})
</script>
